import RankingScopeContext from "../../enums/RankingScopeContext.js";
import ResultsSlice from "../../valueObjects/ResultsSlice.js";

const runningScopeContext = function(slice) {
    return slice instanceof ResultsSlice
        && slice.scope.context === RankingScopeContext.Running.key;
};

export default runningScopeContext;